export default "<div class=\"leagman-spinner\" [ngClass]=\"{'hidden': hideSpinner}\">\r\n  <div></div>\r\n  <div></div>\r\n</div>\r\n";